<template>
<div class="d-flex min-vh-100">
    <Aside />
    <main class="flex-grow-1 bg-light">
        <div class="p-4">
            <h2 class="mb-4">Gestion des Podcasts</h2>

            <!-- Liste des podcasts -->
            <div class="card shadow-sm p-4">
                <div v-if="podcasts.length > 0">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Titre</th>
                                <th>Description</th>
                                <th>Catégorie</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="podcast in podcasts" :key="podcast.id">
                                <td>{{ podcast.title }}</td>
                                <td>{{ podcast.description }}</td>
                                <td>{{ podcast.category }}</td>
                                <td>
                                    <button class="btn btn-primary btn-sm" @click="editPodcast(podcast)">Éditer</button>
                                    <button class="btn btn-danger btn-sm" @click="deletePodcast(podcast.id)">Supprimer</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <p>Aucun podcast trouvé.</p>
                </div>
            </div>

            <!-- Modal d'édition -->
            <div v-if="editingPodcast" class="modal fade show d-block" tabindex="-1" style="display: block;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Modifier le Podcast</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeEditModal"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="handleUpdate">
                                <div class="mb-3">
                                    <label for="title" class="form-label">Titre</label>
                                    <input type="text" id="title" v-model="editingPodcast.title" class="form-control" required />
                                </div>
                                <div class="mb-3">
                                    <label for="description" class="form-label">Description</label>
                                    <textarea id="description" v-model="editingPodcast.description" class="form-control" required></textarea>
                                </div>
                                <div class="mb-3">
                                    <label for="category" class="form-label">Catégorie</label>
                                    <select id="category" v-model="editingPodcast.category" class="form-select" required>
                                        <option v-for="cat in categories" :key="cat" :value="cat">{{ cat }}</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label for="iframe_code" class="form-label">Code Iframe</label>
                                    <textarea id="iframe_code" v-model="editingPodcast.iframe_code" class="form-control" required></textarea>
                                </div>
                                <button type="submit" class="btn btn-primary">Mettre à jour</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import axios from '@/api/axios.js';
import Aside from '@/components/Aside.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        Aside
    },
    data() {
        return {
            podcasts: [],
            editingPodcast: null, // Podcast à éditer
            categories: [
                'Politics', 'Science', 'Environment', 'Sports', 'Culture', 'History', 'Art',
                'Food', 'Business', 'Fashion', 'Music', 'Gaming', 'Automotive', 'Space', 'Legal',
                'Opinion', 'Technology Reviews', 'Startups', 'Mental Health', 'Travel Tips'
            ]
        };
    },
    mounted() {
        this.fetchPodcasts();
    },
    methods: {
        // Récupérer les podcasts depuis l'API
        fetchPodcasts() {
            axios.get('/get-podcasts')
                .then(response => {
                    this.podcasts = response.data.data;
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des podcasts:', error);
                });
        },

        // Ouvrir le modal pour éditer un podcast
        editPodcast(podcast) {
            this.editingPodcast = {
                ...podcast
            }; // Créer une copie du podcast
        },

        // Fermer le modal d'édition
        closeEditModal() {
            this.editingPodcast = null;
        },

        // Mettre à jour un podcast
        handleUpdate() {
            axios.put(`/update-podcasts/${this.editingPodcast.id}`, this.editingPodcast)
                .then(response => {
                    this.fetchPodcasts();
                    this.closeEditModal();
                    Swal.fire({
                        icon: 'success',
                        title: 'Podcast mis à jour',
                        text: 'Le podcast a été mis à jour avec succès.',
                    });
                })
                .catch(error => {
                    console.error('Erreur lors de la mise à jour du podcast:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: 'Erreur lors de la mise à jour du podcast.',
                    });
                });
        },

        // Supprimer un podcast
        deletePodcast(id) {
            Swal.fire({
                title: 'Êtes-vous sûr?',
                text: "Vous ne pourrez pas revenir en arrière!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'Annuler',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`/delete-podcasts/${id}`)
                        .then(() => {
                            this.fetchPodcasts();
                            Swal.fire({
                                icon: 'success',
                                title: 'Podcast supprimé',
                                text: 'Le podcast a été supprimé avec succès.',
                            });
                        })
                        .catch(error => {
                            console.error('Erreur lors de la suppression du podcast:', error);
                            Swal.fire({
                                icon: 'error',
                                title: 'Erreur',
                                text: 'Erreur lors de la suppression du podcast.',
                            });
                        });
                }
            });
        }
    }
};
</script>

<style scoped>
/* Styles personnalisés ici */
</style>
